// extracted by mini-css-extract-plugin
export default {"frameworkSelect":"ContentFrameworkSelector_frameworkSelect__+cR0b"};